import { render, staticRenderFns } from "./filters.pug?vue&type=template&id=31fb1dc2&lang=pug&"
import script from "./filters.js?vue&type=script&lang=js&"
export * from "./filters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fb1dc2')) {
      api.createRecord('31fb1dc2', component.options)
    } else {
      api.reload('31fb1dc2', component.options)
    }
    module.hot.accept("./filters.pug?vue&type=template&id=31fb1dc2&lang=pug&", function () {
      api.rerender('31fb1dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/components/filters/index.vue"
export default component.exports